import { Layout } from "antd";
import React from "react";

const { Footer } = Layout;

function FooterLayout(props:any){
  return (
    <Footer style={{ textAlign: "center" }}>Copyright © RiByte 2025</Footer>
  )
}

export default FooterLayout